import React from '../../../../_snowpack/pkg/react.js';
import { DotSlideButton, DotIndicators, Dot } from './styles.js';

const Dots = ({
  progress,
  paginate,
  page,
  setPage
}) => /*#__PURE__*/React.createElement(DotIndicators, null, /*#__PURE__*/React.createElement(DotSlideButton, {
  className: "prev",
  onClick: () => paginate(-1)
}, '〈'), Object.keys(progress).map(parentKey => Object.keys(progress[parentKey]).map(item => {
  return /*#__PURE__*/React.createElement(Dot, {
    key: `${item}-dot`,
    onClick: () => setPage([progress[parentKey][item].index, 0]),
    done: progress[parentKey][item].completed,
    active: page === progress[parentKey][item].index
  }, progress[parentKey][item].icon);
})), /*#__PURE__*/React.createElement(DotSlideButton, {
  className: "next",
  onClick: () => paginate(1)
}, '〉'));

export default Dots;